(() => {
  function init(root = document) {
    root.querySelectorAll('[data-customer-stories]').forEach(section => {
      if (section.rwStoriesCleanup) return;
      const track = section.querySelector('[data-stories-track]');
      const cards = [...track.children];
      const controls = section.querySelector('[data-stories-controls]');
      const pause = section.querySelector('[data-stories-pause]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let timer, visible = false, hover = false, focus = false, paused = false, index = 0;
      controls.hidden = cards.length < 2;
      const canPlay = () => visible && !hover && !focus && !paused && !reduced.matches && !document.hidden && section.isConnected && track.scrollWidth > track.clientWidth + 2;
      const positions = () => [...new Set(cards.map(card => Math.min(card.offsetLeft - cards[0].offsetLeft, Math.max(0, track.scrollWidth - track.clientWidth))))];
      function refresh() {
        clearInterval(timer);
        if (canPlay()) timer = setInterval(() => go(index + 1), 5500);
      }
      function go(next) {
        const stops = positions();
        index = (next + stops.length) % stops.length;
        track.scrollTo({left: stops[index], behavior: reduced.matches ? 'instant' : 'smooth'});
      }
      const previous = () => { go(index - 1); refresh(); };
      const next = () => { go(index + 1); refresh(); };
      section.querySelector('[data-stories-prev]').addEventListener('click', previous);
      section.querySelector('[data-stories-next]').addEventListener('click', next);
      pause.addEventListener('click', () => {
        paused = !paused;
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', paused ? window.RacewearI18n("play_customer") : window.RacewearI18n("pause_customer"));
        pause.innerHTML = paused ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 10 7-10 7Z"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6v12M15 6v12"/></svg>';
        refresh();
      });
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); event.key === 'ArrowRight' ? next() : previous(); }
      });
      track.addEventListener('scroll', () => {
        let best = Infinity;
        positions().forEach((position, i) => { const distance = Math.abs(position - track.scrollLeft); if (distance < best) {best = distance; index = i;} });
      }, {passive:true});
      section.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hover = true; refresh(); } });
      section.addEventListener('pointerleave', () => { hover = false; refresh(); });
      section.addEventListener('focusin', () => { focus = true; refresh(); });
      section.addEventListener('focusout', () => { focus = false; refresh(); });
      track.addEventListener('touchstart', () => {clearInterval(timer);}, {passive:true});
      track.addEventListener('touchend', refresh, {passive:true});
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; refresh(); }, {threshold: .25});
      observer.observe(section);
      document.addEventListener('visibilitychange', refresh);
      window.addEventListener('resize', refresh);
      reduced.addEventListener('change', refresh);
      section.rwStoriesCleanup = () => {clearInterval(timer); observer.disconnect(); document.removeEventListener('visibilitychange', refresh); window.removeEventListener('resize', refresh); reduced.removeEventListener('change', refresh); delete section.rwStoriesCleanup;};
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-customer-stories]').forEach(section => section.rwStoriesCleanup?.()));
})();
